var FooterSignup = (function() {

  const targetNode = document.querySelector('.newsletter');
  
  // Return early if newsletter element doesn't exist
  if (!targetNode) return;
  
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      if($('.newsletter .submit_button').length > 0){
        
        $('.newsletter .submit_button').on('click',function(e){
            // e.preventDefault()
          console.log("test button")
            if(document.querySelector('#contact_form') && document.querySelector('#contact_form').reportValidity()){
              signUpFooter($(this))
            }
        })
        observer.disconnect()
      }
    };
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);  

// ** Start Footer Scripts **
  let form = '.newsletter #contact_form'
  function signUpFooter(form) {
      var signUpId = '109';
      var email = $('.newsletter [name="contact[email]"]').val()
      console.log(email)
      var acceptsMarketingNew = $(`input[name="agreement-marketing-checkbox"]:checked`).length
      $(`.newsletter .post-sending`).show()
      $(`.newsletter .post-success`).hide()
      request = $.ajax({ // fire off the request
          url: 'https://www.rakwireless.com/api/shopify/generate/discount',
          dataType: 'JSON',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
          },
          type: "get",
          data: null
      });
      request.done(function (response, textStatus, jqXHR){ // callback handler that will be called on success
          discountCode = response.discount_code
          var body = {
              "email": email,
              "Accepts Marketing": [acceptsMarketingNew == 1 ? true : false],
              "attributes":{
                "WELCOME_COUPON_CODE" : discountCode
              }
          }
          var url =
              `https://form-api.rakwireless.com/newsletter/api/contacts/${signUpId}?sort=desc`
          var xhr = new XMLHttpRequest()
          xhr.open('POST', url, true)
          xhr.setRequestHeader('Content-type', 'application/json')
          xhr.setRequestHeader('Accept', 'application/json')
          xhr.send(JSON.stringify(body))
    
          xhr.onload = function() {
              if (xhr.status === 200) {
                $(`.newsletter .post-sending`).hide()
                $(`.newsletter .post-success`).show()
                console.log("Post successfully created!")
                // $(`#new-footer-signup-btn`).prop('disabled', false)
                form.trigger('reset')
                setTimeout(function(){
                  $('.newsletter input[type="submit"]').trigger('click')
                },1000)
              }
          }
        });
  }
})();